import React from "react";

interface FileIconProps {
	fileName: string;
	className?: string;
}

export const FileIcon: React.FC<FileIconProps> = ({
	fileName,
	className = "",
}) => {
	const getIconClass = (fileName: string): string => {
		const extension = fileName.toLowerCase().match(/\.[^.]+$/)?.[0];

		switch (extension) {
			case ".pdf":
				return "mdi-file-pdf-box";
			case ".png":
			case ".jpg":
			case ".jpeg":
				return "mdi-image-outline";
			case ".txt":
			case ".log":
				return "mdi-file-document-outline";
			case ".zip":
				return "mdi-folder-zip-outline";
			case ".json":
				return "mdi-code-json";
			case ".har":
				return "mdi-web";
			case ".ndjson":
				return "mdi-file-table-outline";
			default:
				return "mdi-paperclip";
		}
	};

	return (
		<span
			className={`mdi ${getIconClass(fileName)} ${className}`}
			aria-hidden
		/>
	);
};
